/* src/app/main-layout/components/item-nav/item-nav.component.css */
@layer properties;
a {
  transition-property:
    color,
    background-color,
    border-color,
    outline-color,
    text-decoration-color,
    fill,
    stroke,
    --tw-gradient-from,
    --tw-gradient-via,
    --tw-gradient-to;
  transition-timing-function: var(--tw-ease, var(--default-transition-timing-function, cubic-bezier(0.4, 0, 0.2, 1)));
  transition-duration: var(--tw-duration, var(--default-transition-duration, 150ms));
  --tw-duration: 200ms;
  transition-duration: 200ms;
  --tw-ease: var(--ease-in-out, cubic-bezier(0.4, 0, 0.2, 1));
  transition-timing-function: var(--ease-in-out, cubic-bezier(0.4, 0, 0.2, 1));
}
a.active,
a:hover {
  background-color: var(--color-success-hover, #226e42);
}
li {
  position: relative;
}
li a {
  position: relative;
  z-index: 10;
}
@media (width >= 64rem) {
  .icon {
    margin-bottom: calc(var(--spacing, 0.25rem) * 2);
  }
}
.label {
  display: none;
}
@media (width >= 64rem) {
  .label {
    display: inline-block;
  }
}
.nav-link {
  display: block;
  padding-inline: calc(var(--spacing, 0.25rem) * 2);
  padding-block: calc(var(--spacing, 0.25rem) * 3);
  text-align: center;
  font-size: var(--text-xs, 0.75rem);
  line-height: var(--tw-leading, var(--text-xs--line-height, calc(1 / 0.75)));
  color: var(--color-white, #fff);
  text-decoration-line: none;
}
@property --tw-duration { syntax: "*"; inherits: false; }
@property --tw-ease { syntax: "*"; inherits: false; }
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *,
    ::before,
    ::after,
    ::backdrop {
      --tw-duration: initial;
      --tw-ease: initial;
    }
  }
}
/*! tailwindcss v4.3.0 | MIT License | https://tailwindcss.com */
/*# sourceMappingURL=item-nav.component.css.map */
